import { render, staticRenderFns } from "./cdSkinPackage2.vue?vue&type=template&id=00bc8a58&scoped=true"
import script from "./cdSkinPackage2.vue?vue&type=script&lang=js"
export * from "./cdSkinPackage2.vue?vue&type=script&lang=js"
import style0 from "./cdSkinPackage2.vue?vue&type=style&index=0&id=00bc8a58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bc8a58",
  null
  
)

export default component.exports